import { isRegExp } from 'lodash-es';

/**
 * Simpeler version on the `Array.includes` but allows for matching
 * on regex expressions.
 *
 * @param {Array} collection
 * @param {string} value
 */
export function collectionIncludes(collection: Array<string>, value: string) {
    return !!collection.find((test) => {
        if (isRegExp(test)) {
            return test.test(value);
        }

        return test === value;
    });
}

/**
 * Reverse of `collectionIncludes`
 *
 * @param {Array} collection
 * @param {string} value
 */
export function collectionNotIncludes(collection: Array<string>, value: string) {
    return !collectionIncludes(collection, value);
}
